<!--
Use this template when you want an input field on the same line
and directly after its label
NOTE: the use of prepend within a class hydroware-inline-input
      makes the label and input field appear on the same line
-->
<template>
  <span class="hydroware-inline-input">
    <el-input v-bind=[$attrs,$props] v-on="$listeners">
      <template slot="prepend"> 
        <slot name=label>
        <label class="el-form-item__label">
          <span style="opacity: 0.7;">
            {{labeltext}}
          </span>
        </label>
        </slot>
      </template>
    </el-input>
  </span>
 </template>
 <script>
export default {
    props: ['value', 'labeltext']
  }
</script> 



// WEBPACK FOOTER //
// hydroware-inline-input.vue?94060892